import { useEffect, useRef, useState } from "react";

const solutions = [
  { icon: "ri-apple-line", title: "Apple Ürün Grup Çözümleri", desc: "iPhone, iPad, Mac ve Apple Watch ürünleriyle kurumsal Apple ekosistemi çözümleri." },
  { icon: "ri-smartphone-line", title: "Samsung Ürün Grup Çözümleri", desc: "Samsung mobil cihaz, tablet, monitör ve aksesuar ürünleriyle kurumsal verim çözümleri." },
  { icon: "ri-shopping-cart-2-line", title: "HP Satış & Destek Çözümleri", desc: "HP kurumsal donanım satışı, yazılım çözümleri ve kapsamlı bölgesel destek hizmetleri." },
  { icon: "ri-tools-line", title: "HP Yetkili Servis Çözümleri", desc: "Garantili ve garantisi bitmiş HP ürünleri için yetkili servis, bakım ve onarım hizmetleri." },
  { icon: "ri-server-line", title: "Altyapı & Network Çözümleri", desc: "Yüksek performanslı sunucu, depolama ve kesintisiz network altyapılarıyla iş sürekliliği." },
  { icon: "ri-store-2-line", title: "Perakende, Satış Çözümleri", desc: "POS sistemleri, mağaza içi teknoloji ve perakende sektörüne özel uçtan uca çözümler." },
  { icon: "ri-shield-keyhole-line", title: "Siber Güvenlik Çözümleri", desc: "Endpoint'ten ağa, e-postadan kimliğe — katmanlı siber güvenlik mimarisi." },
  { icon: "ri-vidicon-line", title: "Görüntülü İletişim ve Toplantı Çözümleri", desc: "Hibrit çalışma için konferans, video toplantı ve uzaktan iletişim altyapısı." },
];

export default function Solutions() {
  const [visible, setVisible] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(([entry]) => { if (entry.isIntersecting) setVisible(true); }, { threshold: 0.1 });
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section id="cozumler" ref={ref} className="bg-white py-24 border-t border-line">
      <div className="container-x">
        <div className={`mb-12 transition-all duration-700 ${visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
          <div className="flex items-center gap-3 mb-4">
            <div className="h-px w-12 bg-brand"></div>
            <span className="text-brand text-xs font-semibold tracking-[0.3em] uppercase">Çözümler</span>
          </div>
          <h2 className="font-display font-black uppercase leading-tight text-ink" style={{ fontSize: "clamp(20px, 2.8vw, 34px)", letterSpacing: "-0.02em" }}>
            Çözümlerimiz
          </h2>
          <p className="mt-3 max-w-2xl text-muted text-sm leading-relaxed">
            Kurumların ihtiyaç duyduğu tüm teknoloji çözümlerini tek çatı altında, uçtan uca sunuyoruz.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {solutions.map((s, i) => (
            <div
              key={s.title}
              className={`group bg-white border border-line rounded-2xl p-6 transition-all duration-500 hover:-translate-y-1 hover:border-brand/40 hover:shadow-card ${visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}
              style={{ transitionDelay: `${(i % 4) * 80}ms` }}
            >
              <div className="mb-4 grid h-12 w-12 place-items-center rounded-xl bg-brand/10 text-brand transition-colors group-hover:bg-brand group-hover:text-white">
                <i className={`${s.icon} text-2xl`}></i>
              </div>
              <h3 className="mb-2 font-display text-base font-bold leading-snug text-ink">{s.title}</h3>
              <p className="text-sm leading-relaxed text-muted">{s.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
